import React from 'react';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { Helmet } from 'react-helmet';
import { getToken, authContext } from '../../../config/adalConfig';

import HtmlRender from '../../../components/utils/HtmlRender';
import Content from '../components/Content';
import RegistrationForm from '../components/RegistrationForm';
import { signUp } from '../../../store/auth/AuthActions';
import { hostTitle, isHostProactive, domainName } from '../../../config/ui';

const terms = require('./TermsAndConditions.html');
const policy = require('./PrivacyPolicy.html');

class Register extends React.Component {
  constructor() {
    super();

    this.onSignUp = this.onSignUp.bind(this);
    this.agree = this.agree.bind(this);
  }

  azureLogin(e) {
    e.preventDefault();
    if (!getToken()) {
      authContext.login();
    }
  }

  agree() {
    $(this.refs.regForm.refs.terms).prop('checked', true);
    $("#myModal").modal('hide');
  }

  onSignUp(data) {
    const form = this.refs.regForm.refs.registerForm;
    return this.props.signUp(data).then(auth => {
      if (auth.error) {
        toast.error(
          `Something went wrong. ${this.props.auth.signupError.message}`,
        );
      } else if (auth.payload.data) {
        toast(
          'You have been successfully registered. Please await further instructions.',
        );
        form.reset();
      }
    });
  }

  render() {
    const { auth } = this.props;
    let error = null;
    if (auth && auth.signupError) {
      error = `${
        auth.signupError.message
          ? auth.signupError.message
          : 'Something went wrong. Please try again later.'
      }`;
    }

    let buttonClass = "btn-danger";
    if (isHostProactive()) {
      buttonClass = "btn-custom";
    }

    return (
      <div id="extr-page">
        <Helmet title={`Registration – ${hostTitle()}`} />
        <header id="header" className="animated fadeInDown">
          <div id="logo-group">
            <span id="logo">
              {' '}
              <img src={`assets/img/${domainName()}logo.png`} alt="SmartAdmin" />{' '}
            </span>
          </div>

          <span id="extr-page-header-space">
            <span className="hidden-mobile hiddex-xs">Already registered?</span>
            &nbsp;
            <a href="#login" className={`btn ${buttonClass}`}>
              Sign In
            </a>{' '}
          </span>
        </header>
        <div id="main" role="main" className="animated fadeInDown">
          {/* MAIN CONTENT */}
          <div id="content" className="container">
            <div className="row">
              <Content className="col-xs-12 col-sm-12 col-md-7 col-lg-7 hidden-xs hidden-sm" />
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5">
                <div className="well no-padding">
                  <RegistrationForm
                    ref="regForm"
                    onSubmit={this.onSignUp}
                    error={error}
                    isLoading={auth.isLoading}
                  />
                </div>
                {/* <h5 className="text-center">- Or sign up using -</h5>
                <ul className="list-inline text-center">
                  <li>
                    <a href="#login" className="btn btn-danger" onClick={this.azureLogin}><i className="fa fa-windows"></i> Microsoft</a>
                  </li>
                </ul> */}
              </div>
            </div>
          </div>
        </div>

        {/* Modal Terms & Conditions */}
        <div
          className="modal fade"
          id="myModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  &times;
                </button>
                <h4 className="modal-title" id="myModalLabel">
                  Terms & Conditions
                </h4>
              </div>
              <div className="modal-body custom-scroll terms-body">
                <HtmlRender html={terms} />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-default"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <button type="button" className="btn btn-primary" id="i-agree" onClick={this.agree}>
                  <i className="fa fa-check" /> I Agree
                </button>

                <button
                  type="button"
                  className="btn btn-danger pull-left hide"
                  disabled
                  id="print"
                >
                  <i className="fa fa-print" /> Print
                </button>
              </div>
            </div>
            {/* /.modal-content */}
          </div>
          {/* /.modal-dialog */}
        </div>
        {/* /.modal */}


        {/* Modal Privacy Policy */}
        <div
          className="modal fade"
          id="modalPrivacyPolicy"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  &times;
                </button>
                <h4 className="modal-title" id="myModalLabel">
                  Privacy Policy
                </h4>
              </div>
              <div className="modal-body custom-scroll terms-body">
                <HtmlRender html={policy} />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-default"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-danger pull-left hide"
                  disabled
                  id="print"
                >
                  <i className="fa fa-print" /> Print
                </button>
              </div>
            </div>
            {/* /.modal-content */}
          </div>
          {/* /.modal-dialog */}
        </div>
        {/* /.modal */}

        <ToastContainer />
      </div>
    );
  }
}
export default connect(
  state => ({ auth: state.auth }),
  dispatch => ({
    signUp: data => dispatch(signUp(data)),
  }),
)(Register);



// WEBPACK FOOTER //
// ./src/routes/auth/containers/Register.js